// extracted by mini-css-extract-plugin
export default {"cus_input":"ForgotPassModal_cus_input__ZqHMD","input_mar":"ForgotPassModal_input_mar__Ljj-7","lgn_btn_div":"ForgotPassModal_lgn_btn_div__aqqLg"};